import { useState } from 'react';

export default function ZipCodeModal({ isOpen, onClose, onSubmit, initialZipCode = '' }) {
  const [zipCode, setZipCode] = useState(initialZipCode);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = zipCode.trim();
    
    // Validate zipcode (5 digits, optionally with -4 more digits)
    if (!trimmed) {
      setError('Please enter a zipcode.');
      return;
    }
    
    if (!/^\d{5}(-\d{4})?$/.test(trimmed)) {
      setError('Please enter a valid zipcode (e.g., 78201 or 78201-1234).');
      return;
    }

    setError('');
    onSubmit(trimmed);
    onClose();
  };

  const handleClose = () => {
    setZipCode(initialZipCode);
    setError('');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full p-6 space-y-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-slate-100">
            Enter Your Zipcode
          </h2>
          <button
            onClick={handleClose}
            className="text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors"
            aria-label="Close"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <p className="text-slate-600 dark:text-slate-400">
          Please enter your zipcode to discover garage sales near you.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              value={zipCode}
              onChange={(e) => {
                setZipCode(e.target.value);
                setError('');
              }}
              placeholder="Enter zipcode (e.g., 78201)"
              className="w-full rounded-xl border-2 border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 px-4 py-3 text-lg focus:outline-none focus:border-indigo-500 dark:focus:border-indigo-400"
              pattern="[0-9]{5}(-[0-9]{4})?"
              maxLength="10"
              autoFocus
            />
            {error && (
              <p className="mt-2 text-sm text-red-600 dark:text-red-400">{error}</p>
            )}
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 px-4 py-3 rounded-xl border-2 border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 font-semibold hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-3 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white font-semibold transition-colors"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
